import {apolloClient} from "@App/graphql/client";
import {GeoSuggestQuery, GET_GEOSUGGEST,} from "@App/graphql/queries";
import {useEffect} from 'react';
import {useLocation, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {actionCreators, State, store} from '@App/state'
import {bindActionCreators} from "@reduxjs/toolkit";

/**
 * A custom hook that checks if all needed data was loaded from the api on component mount
 * and returns a method to parse the data to the url query parameters.
 */
export const usePlaceParameters = () => {
    const dispatch = useDispatch();
    const {choosePlace} = bindActionCreators(actionCreators, dispatch)
    const [searchParams] = useSearchParams()
    const {hash} = useLocation()
    const place = useSelector((state: State) => state.orders.place)

    //get location query from old HashRouter Links and
    if (hash && hash !== 'null' && hash !== undefined) {
        // searchParams.set('location', hash.match(/(?<=location=).*(?=&*)/g)[0]) <-- safari doesnt support this
        if (hash.includes('location=')) {
            searchParams.set('location', hash.split('location=')[1].split("&")[0])
        }
    }

    useEffect(() => {
        const placeQuery = searchParams.get('place')
        const locationQuery = searchParams.get('location')

        if (locationQuery && locationQuery !== 'null' && !place && !placeQuery) {
            apolloClient.query<GeoSuggestQuery>({
                query: GET_GEOSUGGEST, variables: {
                    search: locationQuery,
                }
            }).then((result) => {
                choosePlace(result.data.geosuggest[0])
                searchParams.set('location', null)
            })
        }

        // get place from api if not in state
        if (placeQuery && placeQuery !== 'null' && (!place || !place.lat || place.id !== placeQuery)) {
            apolloClient.query<GeoSuggestQuery>({
                query: GET_GEOSUGGEST, variables: {
                    placeId: placeQuery,
                }
            }).then((result) => {
                choosePlace(result.data.geosuggest[0])
            })
        }
    }, [])

    // if place changes, automatically update the query parameters
    useEffect(() => {
        if (place && place.id !== searchParams.get('place')) {
            searchParams.set('place', place.id)
        }
    }, [place])

    const placeQueryParams = () => {
        return {
            // add place if existing
            ...(store.getState().orders.place && {
                place: store.getState().orders.place.id
            }),
        }
    }

    return {placeQueryParams}
}

